
export const ExportType = {
    Contracted: 1,
    InstallmentByInsurersAndMakers: 20,
    InstallmentByMakers: 21,
    InstallmentByInsurers: 22,
    InsurancesNew: 25,
    InsuranceOverview: 3,
    Insurances: 4,
    ContractedPoleas: 10,
    NewKarat: 105,
    NewContractedRCI: 109,
    InsurerProduct: 40,
    InsurerProductAddition: 41,
    Risks: 42,
    Selection: 43,
    NewCafeterieUCL: 160,
    NewCafeterieRCI: 161,
    CebiaStats: 30,
    ApiOdhadZdarma: 213,
    Offers: 300,
    OrganizationUnits: 11,
    KaratOu: 7,
    Users: 12,
    KaratUsers: 6,
} as const

export type ExportType = typeof ExportType[keyof typeof ExportType]
